var _g, _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPctStep04({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 110,
    viewBox: "0 0 150 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_810_6526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.22 21.5H46.82C45.5442 21.5 44.51 22.5342 44.51 23.81V92.05C44.51 93.3258 45.5442 94.36 46.82 94.36H112.22C113.496 94.36 114.53 93.3258 114.53 92.05V23.81C114.53 22.5342 113.496 21.5 112.22 21.5Z",
    fill: "#CEDFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.15 16.6801H39.7301C39.1502 16.6801 38.6801 17.1502 38.6801 17.7301V86.9801C38.6801 87.56 39.1502 88.0301 39.7301 88.0301H106.15C106.73 88.0301 107.2 87.56 107.2 86.9801V17.7301C107.2 17.1502 106.73 16.6801 106.15 16.6801Z",
    fill: "white",
    stroke: "#82BCFF",
    strokeWidth: 3.35,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.89 27.47H50.98V35.38H58.89V27.47Z",
    fill: "#CEDFFF",
    stroke: "#82BCFF",
    strokeWidth: 1.19,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.22 31.4299H94.5",
    stroke: "#82BCFF",
    strokeWidth: 2.37,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.89 41.4301H50.98V49.3401H58.89V41.4301Z",
    fill: "#CEDFFF",
    stroke: "#82BCFF",
    strokeWidth: 1.19,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.22 45.39H94.5",
    stroke: "#82BCFF",
    strokeWidth: 2.37,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.89 55.4H50.98V63.31H58.89V55.4Z",
    fill: "#CEDFFF",
    stroke: "#82BCFF",
    strokeWidth: 1.19,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.22 59.35H94.5",
    stroke: "#82BCFF",
    strokeWidth: 2.37,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.89 69.36H50.98V77.27H58.89V69.36Z",
    fill: "#CEDFFF",
    stroke: "#82BCFF",
    strokeWidth: 1.19,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.22 73.3199H94.5",
    stroke: "#82BCFF",
    strokeWidth: 2.37,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43 62.77C114.223 62.77 119.73 57.2631 119.73 50.47C119.73 43.6769 114.223 38.17 107.43 38.17C100.637 38.17 95.13 43.6769 95.13 50.47C95.13 57.2631 100.637 62.77 107.43 62.77Z",
    stroke: "white",
    strokeWidth: 5.68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.18 65.73C110.41 65.73 113.55 64.61 116.1 62.56L122.68 69.47L125.25 66.81L118.67 59.9C120.66 57.27 121.74 54.03 121.75 50.69C121.75 42.4 115.21 35.65 107.18 35.65C99.15 35.65 92.61 42.4 92.61 50.69C92.61 58.98 99.15 65.73 107.18 65.73V65.73ZM107.18 39.4C113.21 39.4 118.11 44.46 118.11 50.68C118.11 56.9 113.21 61.96 107.18 61.96C101.15 61.96 96.25 56.9 96.25 50.68C96.25 44.46 101.15 39.4 107.18 39.4Z",
    stroke: "white",
    strokeWidth: 5.68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.75 48.03C110.44 48.74 110.82 49.69 110.82 50.69H114.46C114.46 49.7 114.27 48.72 113.91 47.81C113.54 46.9 113 46.07 112.33 45.37C109.57 42.53 104.79 42.53 102.04 45.37L104.61 48.03C105.99 46.6 108.38 46.61 109.76 48.03H109.75Z",
    stroke: "white",
    strokeWidth: 5.68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.43 62.77C114.223 62.77 119.73 57.2631 119.73 50.47C119.73 43.6769 114.223 38.17 107.43 38.17C100.637 38.17 95.13 43.6769 95.13 50.47C95.13 57.2631 100.637 62.77 107.43 62.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.18 65.73C110.41 65.73 113.55 64.61 116.1 62.56L122.68 69.47L125.25 66.81L118.67 59.9C120.66 57.27 121.74 54.03 121.75 50.69C121.75 42.4 115.21 35.65 107.18 35.65C99.15 35.65 92.61 42.4 92.61 50.69C92.61 58.98 99.15 65.73 107.18 65.73ZM107.18 39.4C113.21 39.4 118.11 44.46 118.11 50.68C118.11 56.9 113.21 61.96 107.18 61.96C101.15 61.96 96.25 56.9 96.25 50.68C96.25 44.46 101.15 39.4 107.18 39.4Z",
    fill: "#50A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.75 48.03C110.44 48.74 110.82 49.69 110.82 50.69H114.46C114.46 49.7 114.27 48.72 113.91 47.81C113.54 46.9 113 46.07 112.33 45.37C109.57 42.53 104.79 42.53 102.04 45.37L104.61 48.03C105.99 46.6 108.38 46.61 109.76 48.03H109.75Z",
    fill: "#50A1FF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 66,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#50A1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.52 79.41C31.87 79.37 32.23 79.35 32.9 79.35H37.06C37.7 79.35 38.01 79.36 38.44 79.41V78.14C38.05 78.19 37.74 78.2 37.05 78.2H32.88C32.27 78.2 31.91 78.18 31.52 78.14V79.41ZM39.41 83.93C38.94 83.98 38.6 84 37.93 84H32.07C31.36 84 31.01 83.98 30.59 83.93V85.23C31.06 85.18 31.54 85.16 32.1 85.16H37.96C38.51 85.16 38.96 85.18 39.41 85.23V83.93ZM45.25 78.58C45.33 78.38 45.37 78.26 45.43 78.1C45.63 77.57 45.65 77.51 45.73 77.32L44.53 77.11C44.21 78.69 43.55 79.89 42.5 80.83C42.84 81.07 43.08 81.3 43.33 81.64C44 80.92 44.39 80.36 44.81 79.54H48.13C47.83 80.28 47.49 80.8 46.89 81.41C47.38 81.69 47.45 81.74 47.81 82.04C48.45 81.24 48.8 80.64 49.23 79.62C49.35 79.34 49.38 79.27 49.45 79.1L48.85 78.52C48.63 78.56 48.34 78.58 47.88 78.58H45.25ZM40.53 78.26C41.33 78.89 41.63 79.19 42.25 79.95L43.11 79.14C42.49 78.46 42.13 78.12 41.39 77.54L40.53 78.26ZM42.77 81.63C42.18 82.4 41.87 82.73 41.19 83.32C40.73 83.72 40.53 83.87 40.32 83.98L41.07 85.03C41.16 84.94 41.2 84.9 41.4 84.72C42.19 84 42.82 83.32 43.46 82.5L42.77 81.63ZM45.13 80C45.16 80.18 45.17 80.3 45.17 80.45C45.17 81.92 44.69 83.23 43.83 84.1C43.29 84.65 42.74 85.01 41.92 85.34C42.24 85.71 42.39 85.92 42.55 86.29C43.51 85.83 44.18 85.36 44.7 84.76C45.15 84.23 45.52 83.53 45.73 82.79C45.98 83.57 46.4 84.25 47 84.85C47.54 85.38 48.03 85.73 49.01 86.27C49.19 85.87 49.37 85.58 49.65 85.21C48.84 84.87 48.46 84.66 47.97 84.27C47.34 83.78 46.85 83.13 46.57 82.43C46.38 81.93 46.26 81.15 46.26 80.42C46.26 80.26 46.27 80.13 46.3 80H45.13Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_810_6526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92.18,
    height: 79.36,
    fill: "white",
    transform: "translate(37 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPctStep04);
export default __webpack_public_path__ + "static/media/pct_step04.f78bea7103ed0bbe29a5ec1895404861.svg";
export { ForwardRef as ReactComponent };